import { render, staticRenderFns } from "./purposepreview.vue?vue&type=template&id=c6376006&"
import script from "./purposepreview.vue?vue&type=script&lang=js&"
export * from "./purposepreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports